import React from "react";

// extraProps: props inyectadas al screen activo (ej. habilitarSiguiente) sin
// tocar cada definición de screen0..screenN en los procesos.
const ModalSCScreens = ({ value, screens, extraProps = {} }) => {
  if (
    value === undefined ||
    value === null ||
    typeof value !== "number" ||
    Number(value) < 0 ||
    screens === undefined ||
    screens === null ||
    screens.length === 0
  ) {
    return;
  }
  const onResolveScreen = () => {
    var Element = screens[`screen${Number(value)}`];
    if (Element === undefined || Element === null)
      return <div>No element0</div>;
    else return React.cloneElement(Element, extraProps);
  };

  return onResolveScreen();
};

export default ModalSCScreens;
